// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"af4a3ff4","488":"9da911e5","893":"93e0f09b","905":"d01eafca","976":"2d6475a7"}[chunkId] + ".chunk.js";
};